import { render, staticRenderFns } from "./PlatformIntroduction.vue?vue&type=template&id=4cbaa832&scoped=true&"
import script from "./PlatformIntroduction.vue?vue&type=script&lang=js&"
export * from "./PlatformIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./PlatformIntroduction.vue?vue&type=style&index=0&id=4cbaa832&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbaa832",
  null
  
)

export default component.exports